export default "__VITE_ASSET__CgyRsI0C__"